export const english = {
  dateFormats: {
    currentDateFormat: "eee, do LLLL",
    currentTimeFormat: "HH:mm",
    dateDayMonth: "eeee do LLLL",
    dateDay: "eeee do",
    hoursMinutes: "HH:mm",
  },
  StatusProvider: {
    "Screen is active but no token is present":
      "Screen is active but no token is present",
    "Network error": "Network error",
    "Checking display status": "Checking display status",
    "Failed to get display status": "Failed to get display status",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "If this issue persists, please contact your Teamworks administrator.":
      "If this issue persists, please contact your Teamworks administrator.",
    "This is usually due to a network error while setting up your device. Please reset your device using the button below and try again.":
      "This is usually due to a network error while setting up your device. Please reset your device using the button below and try again.",
    "Setup failed to complete": "Setup failed to complete",
    "Please reset your device using the button below and try again.":
      "Please reset your device using the button below and try again.",
  },
  ConfigProvider: {
    "Loading configuration": "Loading configuration",
  },
  AppProvider: {
    Loading: "Loading",
    "No configuration selected": "No configuration selected",
    "We could not find a configuration for the given code. Please contact your Teamworks administrator.":
      "We could not find a configuration for the given code. Please contact your Teamworks administrator.",
    "This device has been registered, but no configuration has been set yet. Dont worry, you can easily update this device in the digital displays management app.":
      "This device has been registered, but no configuration has been set yet. Dont worry, you can easily update this device in the digital displays management app.",
    "Network error: failed to load playlist":
      "Network error: failed to load playlist",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "Resetting, please wait...": "Resetting, please wait...",
  },
  UpdatesProvider: {
    "Checking for update": "Checking for update",
    "Downloading update": "Downloading update",
  },
  InteractionScreen: {
    "Loading...": "Loading...",
    "Press any key to begin": "Press any key to begin",
    "No configurations assigned": "No configurations assigned",
    "You can assign a configuration or a playlist to run on this device in the Digital Displays management app.":
      "You can assign a configuration or a playlist to run on this device in the Digital Displays management app.",
  },
  SetupScreen: {
    "Scan the QR code on your camera app":
      "Scan the QR code on your camera app",
  },
  TemplateScreen: {
    "Events page {{count}} of {{total}}": "Events page {{count}} of {{total}}",
    Today: "Today",
    "All day": "All day",
    Tomorrow: "Tomorrow",
  },
  ErrorScreen: {
    "Something went wrong": "Something went wrong",
    "Sorry for the inconvience, our engineers have been notified and will be working on a fix":
      "Sorry for the inconvience, our engineers have been notified and will be working on a fix",
    "If this issue persists, please contact your account manager":
      "If this issue persists, please contact your account manager",
    "Reset device": "Reset device",
    "Your IP address may need to be permitted: {{ip}}":
      "Your IP address may need to be permitted: {{ip}}",
    "The app will attempt to automatically reset in {{seconds}} seconds":
      "The app will attempt to automatically reset in {{seconds}} seconds",
  },
  NextMatch: {
    days: "days",
    hours: "hours",
    minutes: "minutes",
    seconds: "seconds",
  },
  MediaContentCarosel: {
    "Media not found": "Media not found",
  },
  PlaylistProvider: {
    "Loading...": "Loading...",
    "Loading playlist": "Loading playlist",
  },
  ScreenFooter: {
    Hardcoded: "Hardcoded",
  },
  NotFoundLayout: {
    "Configuration not found": "Configuration not found",
  },
  StrengthWorkoutBoard: {
    "No Workout Selected": "No Workout Selected",
    "Select a workout from the Digital Display tab in S&C to display it here":
      "Select a workout from the Digital Display tab in S&C to display it here",
  },
  WeatherWidget: {
    "Weather unavailable": "Weather unavailable",
  },
  NutritionMenu: {
    "Failed to fetch menu": "Failed to fetch menu",
  },
  NutritionDiningStation: {
    "Failed to fetch dining station": "Failed to fetch dining station",
    "Add ons will affect nutrition information":
      "Add ons will affect nutrition information",
  },
  Weather: {
    Today: "Today",
    "No weather data to show, please contact your Teamworks administrator.":
      "No weather data to show, please contact your Teamworks administrator.",
    Clear: "Clear",
    Clouds: "Cloudy",
    Rain: "Rain",
    Drizzle: "Drizzle",
    Thunderstorm: "Thunderstorm",
    Snow: "Snow",
    Mist: "Mist",
    Smoke: "Smoke",
    Haze: "Haze",
    Dust: "Dust",
    Fog: "Fog",
    Sand: "Sand",
    Ash: "Volcanic Ash",
    Squall: "Squall",
    Tornado: "Tornado",
  },
};

export type Localisation = typeof english;
export type Namespace = keyof Localisation;
